var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.26 22.2483H8.73998C3.82998 22.2483 1.72998 20.1483 1.72998 15.2383V15.1083C1.72998 10.6683 3.47998 8.52832 7.39998 8.15832C7.79998 8.12832 8.17998 8.42832 8.21998 8.83832C8.25998 9.24832 7.95998 9.61832 7.53998 9.65832C4.39998 9.94832 3.22998 11.4283 3.22998 15.1183V15.2483C3.22998 19.3183 4.66998 20.7583 8.73998 20.7583H15.26C19.33 20.7583 20.77 19.3183 20.77 15.2483V15.1183C20.77 11.4083 19.58 9.92832 16.38 9.65832C15.97 9.61832 15.66 9.25832 15.7 8.84832C15.74 8.43832 16.09 8.12832 16.51 8.16832C20.49 8.50832 22.27 10.6583 22.27 15.1283V15.2583C22.27 20.1483 20.17 22.2483 15.26 22.2483Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 15.7511C11.59 15.7511 11.25 15.4111 11.25 15.0011V3.62109C11.25 3.21109 11.59 2.87109 12 2.87109C12.41 2.87109 12.75 3.21109 12.75 3.62109V15.0011C12.75 15.4111 12.41 15.7511 12 15.7511Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3498 6.60141C15.1598 6.60141 14.9698 6.53141 14.8198 6.38141L11.9998 3.56141L9.17984 6.38141C8.88984 6.67141 8.40984 6.67141 8.11984 6.38141C7.82984 6.09141 7.82984 5.61141 8.11984 5.32141L11.4698 1.97141C11.7598 1.68141 12.2398 1.68141 12.5298 1.97141L15.8798 5.32141C16.1698 5.61141 16.1698 6.09141 15.8798 6.38141C15.7398 6.53141 15.5398 6.60141 15.3498 6.60141Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.df6a3ca5f9768431a5751c614b347817.svg";
export { ForwardRef as ReactComponent };